<template>
  <div
    class="scout-type d-flex align-items-end mt-2"
    v-if="applicant.scoutType || applicant.scoutedUser"
  >
    <h3>スカウト種別</h3>
    <span class="scout-type-text">{{ applicant.scoutType || '' }}</span>
    <span>設定者： {{ applicant.scoutedBy || '' }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ScoutTypeSection',
  // props: {
  //   applicant: {
  //     type: Object,
  //     required: true
  //   }
  // },
  computed: {
    ...mapGetters({
      applicant: 'getProfile',
    }),
  },
};
</script>

<style scoped>
h3 {
  font-size: 18px;
  font-weight: 600;
}
.scout-type {
  gap: 20px;
  padding: 5px;
  background-color: #fff;
  border-radius: 10px;
  /* Add any specific styles for the scout type section if needed */
}

.scout-type-text {
  width: 120px;
  height: 32px;
  background: #787878;
  border-radius: 3px;
  text-align: center;
  padding: 5px;
  color: #fff;
}</style
>xt
